import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const SectionTitle = ({ title, description }) => (
  <Side>
    <Typography fontWeight={500} fontSize={18}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    )}
  </Side>
);

const KycContact = ({ d }) => {
  return (
    <Row>
      <SectionTitle
        title="Contact & Location"
        description="Business contact details and address."
      />
      <Grid>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Business Email" value={d?.businessEmail} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Business Phone"
            value={d?.businessPhoneNumber}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Country" value={d?.country || "-"} />
        </Box>

        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="State" value={d?.state} />
        </Box>

        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="LGA" value={d?.lga} />
        </Box>

        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="City" value={d?.city} />
        </Box>

        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Street Address" value={d?.streetAddress} />
        </Box>
      </Grid>
    </Row>
  );
};

export default KycContact;
